<template>
  <div v-if="bancos" :class="['col-xs-12', `col-md-${size}`]">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :name="name"
      :options="bancos"
      :data-vv-as="label"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import BancoService from "../../../../domain/corpore/BancoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-banco",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
  },
  asyncComputed: {
    bancos() {
      const bancoService = new BancoService(this.$http);
      return bancoService
        .getBancos()
        .then(result => {
          return result.map(banco => ({
            value: `${banco.NUMBANCO} - ${banco.NOME}`,
            text: banco.NOME
          }));
        })
        .catch(err => {
          SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
        });
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Banco.vue